import About from "../components/--about/About/About";

const AboutPage = () => {
  return <About />;
};

export default AboutPage;
